export default __webpack_public_path__ + "static/media/Premier_Membership_Icon_2.3aac1103.svg";